import React from "react";
import type { IconT } from "types/utils";
import { theme } from "styles/themes";

const EyeIconOutline = ({ height = "11", width = "15", fill = theme.colors["blue-ribbon"] }: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.925915 5.89212C0.835124 5.74836 0.789728 5.67648 0.764316 5.56561C0.745228 5.48233 0.745228 5.351 0.764316 5.26772C0.789728 5.15685 0.835124 5.08497 0.925915 4.94121C1.67619 3.75323 3.90943 0.75 7.31277 0.75C10.7161 0.75 12.9494 3.75323 13.6996 4.94121C13.7904 5.08497 13.8358 5.15685 13.8612 5.26772C13.8803 5.351 13.8803 5.48233 13.8612 5.56561C13.8358 5.67648 13.7904 5.74836 13.6996 5.89212C12.9494 7.08011 10.7161 10.0833 7.31277 10.0833C3.90943 10.0833 1.67619 7.08011 0.925915 5.89212Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.31277 7.41667C8.41734 7.41667 9.31277 6.52124 9.31277 5.41667C9.31277 4.3121 8.41734 3.41667 7.31277 3.41667C6.2082 3.41667 5.31277 4.3121 5.31277 5.41667C5.31277 6.52124 6.2082 7.41667 7.31277 7.41667Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeIconOutline;
